import React, { Fragment, useRef } from 'react';
import { translate } from '../Services/translation';
import TopLinkMenu from './TopLinkMenu';

const NavigationItem = ({
  links = [],
  siteLink = null,
  contentLink = null,
}) => {
  const menuRef = useRef(null);
  const toggleMenu = (e) => {
    e.preventDefault();
    menuRef.current.classList.toggle('navbar__menu--show');
  };
  const additionClass =
    contentLink && contentLink.attributes
      ? contentLink.attributes.cssValue
      : null;
  const selectedClass =
    contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
  const hasChildrenClass = links.length > 0 ? 'has-children' : null;
  const hasNameOrChildren = (link) =>
    link.name || (link.links || []).length > 0;
  const activeClass =
    contentLink && contentLink.url === location.pathname ? 'active' : null;

  return (
    <Fragment>
      {!contentLink ? (
        <a
          className="navbar__link--block navbar__icon--menu navbar__icon"
          onClick={toggleMenu}
          rel="nofollow"
          href="#"
          title={translate('general.menu') || 'menu'}
        ></a>
      ) : (
        <Fragment>
          <a
            className={`top-link__link--block ${selectedClass} ${
              hasChildrenClass || ''
            } ${additionClass || ''} ${activeClass || ''}`}
            href={contentLink.url || '#'}
          >
            <span
              className="top-link__title"
              dangerouslySetInnerHTML={{ __html: contentLink.name }}
            ></span>
          </a>
          {links.length > 0 && (
            <i
              className="navbar__icon--caret-right navbar__icon navbar__icon--open"
              onClick={toggleMenu}
            ></i>
          )}
        </Fragment>
      )}

      {links.length > 0 && (
        <div className="navbar__menu" ref={menuRef}>
          <div className="navbar__menu-header">
            {!contentLink ? (
              <span
                className="navbar__icon navbar__icon--close"
                onClick={toggleMenu}
              ></span>
            ) : (
              <Fragment>
                <i
                  className="navbar__icon--caret-left navbar__icon"
                  onClick={toggleMenu}
                ></i>
                <span
                  className="navbar__title"
                  onClick={toggleMenu}
                  dangerouslySetInnerHTML={{
                    __html: contentLink.name,
                  }}
                ></span>
              </Fragment>
            )}
          </div>
          <div className="navbarlinks">
            {siteLink && (
              <div className="top-link top-link--bufab">
                <a className="top-link__link--block" href={siteLink.url}>
                  <span className="top-link__title external">
                    {siteLink.name}
                  </span>
                </a>
              </div>
            )}
            {!siteLink && (
              <div className="top-link top-link--bufab">
                <a
                  className="top-link__link--block"
                  href="https://www.bufab.com"
                >
                  <span className="top-link__title external">Bufab.com</span>
                </a>
              </div>
            )}
            {links.length > 0 &&
              links.map(
                (link, index) =>
                  hasNameOrChildren(link) && (
                    <div className="top-link" key={index}>
                      <NavigationItem links={link.links} contentLink={link} />
                    </div>
                  )
              )}
            <TopLinkMenu />
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default NavigationItem;
